import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import useSEO from '../hooks/useSEO';

const NotFoundPage = () => {
    useSEO({
        title: "Page Not Found | Prime Rehab Industries",
        description: "The page you are looking for could not be found on Prime Rehab Industries.",
        canonical: "https://www.primerehabindustries.in/",
        robots: "noindex, follow"
    });

    return (
        <div className="not-found-page">
            <Navbar />
            <main style={{ minHeight: '50vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '4rem 1rem' }}>
                <h1 style={{ fontSize: '2rem', marginBottom: '1rem' }}>Page Not Found</h1>
                <p style={{ marginBottom: '1.5rem' }}>The page you're looking for doesn't exist or may have moved.</p>
                <Link to="/" style={{ color: '#4872a4', fontWeight: 600 }}>Return to Homepage</Link>
            </main>
            <Footer />
        </div>
    );
};

export default NotFoundPage;
